export const TYPE_CREATE_CITATIONS = 'create citations' as const
export const TYPE_CHECK_PAPER = 'check paper' as const

export const HOMEPAGE_CARD = 'homepage-card'
